import React, { useState, useEffect } from 'react';
import axios from 'axios';
import appConfig from '../../config/appConfig';
import { invalidarCachePlanes } from '../../services/planesServicio';

var PLANES_META = [
    { key: 'MENU_QR',           nombre: 'Komity Pedidos Web',    icono: '📱', desc: 'Solo pedidos online, sin POS ni caja' },
    { key: 'POS',                nombre: 'Komity POS Take Away', icono: '🏪', desc: 'Venta en local sin mesas' },
    { key: 'RESTAURANTE',        nombre: 'Plan Restaurante',     icono: '🍽️', desc: 'POS + mesas. Menú QR incluido gratis' },
    { key: 'PEDIDOS_WEB_ADDON',  nombre: 'Add-on Pedidos Web',   icono: '➕', desc: 'Suma pedidos online a POS o Restaurante' },
];

export default function ConfiguracionPlanes({ onAuthError }) {
    var [precios, setPrecios] = useState({ MENU_QR: '14990', POS: '19990', RESTAURANTE: '24990', PEDIDOS_WEB_ADDON: '9990' });
    var [guardando, setGuardando] = useState(null); // key del plan que se está guardando
    var [mensajes, setMensajes] = useState({});     // { key: { tipo: 'ok'|'error', texto } }
    var [cargando, setCargando] = useState(true);
    var [errorGlobal, setErrorGlobal] = useState('');

    var token = localStorage.getItem('superadmin_token');
    var authHeaders = { headers: { token: token, 'Content-Type': 'application/json' } };

    useEffect(function() {
        cargar();
    }, []);

    async function cargar() {
        setCargando(true);
        setErrorGlobal('');
        try {
            var res = await axios.get(appConfig.api_url + '/api/planes/precios');
            if (res.data && res.data.status === 'success') {
                var mapa = {};
                res.data.planes.forEach(function(p) {
                    mapa[p.plan_key] = String(p.precio);
                });
                setPrecios(mapa);
            }
        } catch (e) {
            setErrorGlobal('No se pudo cargar la configuración actual.');
        } finally {
            setCargando(false);
        }
    }

    async function guardarPlan(planKey) {
        var valor = precios[planKey];
        var num = parseInt(valor, 10);
        if (isNaN(num) || num < 0) {
            setMensajes(function(prev) {
                var next = Object.assign({}, prev);
                next[planKey] = { tipo: 'error', texto: 'Ingresa un valor numérico válido.' };
                return next;
            });
            return;
        }

        setGuardando(planKey);
        setMensajes(function(prev) {
            var next = Object.assign({}, prev);
            delete next[planKey];
            return next;
        });

        try {
            var res = await axios.put(
                appConfig.api_url + '/api/bimba/planes/' + planKey + '/precio',
                { precio: num },
                authHeaders
            );
            if (res.data && res.data.status === 'success') {
                invalidarCachePlanes();
                setMensajes(function(prev) {
                    var next = Object.assign({}, prev);
                    next[planKey] = { tipo: 'ok', texto: 'Guardado correctamente.' };
                    return next;
                });
                setTimeout(function() {
                    setMensajes(function(prev) {
                        var next = Object.assign({}, prev);
                        delete next[planKey];
                        return next;
                    });
                }, 3000);
            } else {
                throw new Error((res.data && res.data.message) || 'Error desconocido');
            }
        } catch (e) {
            if (e.response && e.response.status === 403) {
                onAuthError && onAuthError();
                return;
            }
            var msg = (e.response && e.response.data && e.response.data.message) || e.message || 'Error al guardar.';
            setMensajes(function(prev) {
                var next = Object.assign({}, prev);
                next[planKey] = { tipo: 'error', texto: msg };
                return next;
            });
        } finally {
            setGuardando(null);
        }
    }

    function handleChange(planKey, valor) {
        setPrecios(function(prev) {
            var next = Object.assign({}, prev);
            next[planKey] = valor;
            return next;
        });
    }

    return (
        <div style={{ maxWidth: '800px', margin: '0 auto', padding: '32px 24px' }}>
            {/* Título */}
            <div style={{ marginBottom: '28px' }}>
                <h2 style={{ fontSize: '20px', fontWeight: 700, color: '#1a1a2e', margin: '0 0 4px' }}>
                    Precios de planes
                </h2>
                <p style={{ fontSize: '14px', color: '#6b7280', margin: 0 }}>
                    Estos precios se muestran en la landing page y en el modal de planes del panel de clientes.
                </p>
            </div>

            {errorGlobal && (
                <div style={{
                    padding: '12px 16px', background: '#fef2f2', border: '1px solid #fecaca',
                    borderRadius: '10px', color: '#dc2626', fontSize: '13px', marginBottom: '20px',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                }}>
                    <span>{errorGlobal}</span>
                    <button onClick={cargar} style={{
                        background: '#dc2626', color: '#fff', border: 'none',
                        borderRadius: '6px', padding: '4px 10px', fontSize: '12px',
                        cursor: 'pointer', fontWeight: 600,
                    }}>
                        Reintentar
                    </button>
                </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                {PLANES_META.map(function(meta) {
                    var msg = mensajes[meta.key];
                    var esGuardando = guardando === meta.key;

                    return (
                        <div key={meta.key} style={{
                            background: '#fff',
                            border: '1.5px solid #e5e7eb',
                            borderRadius: '14px',
                            padding: '20px 24px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '20px',
                            flexWrap: 'wrap',
                        }}>
                            {/* Icono + info */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '14px', flex: '1', minWidth: '200px' }}>
                                <div style={{
                                    width: '48px', height: '48px', borderRadius: '12px',
                                    background: '#f3f4f6',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    fontSize: '22px', flexShrink: 0,
                                }}>
                                    {meta.icono}
                                </div>
                                <div>
                                    <div style={{ fontWeight: 700, fontSize: '15px', color: '#1a1a2e' }}>{meta.nombre}</div>
                                    <div style={{ fontSize: '12px', color: '#9ca3af', marginTop: '2px' }}>{meta.desc}</div>
                                </div>
                            </div>

                            {/* Input precio */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <div style={{ position: 'relative' }}>
                                    <span style={{
                                        position: 'absolute', left: '12px', top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: '#9ca3af', fontSize: '14px', fontWeight: 600,
                                        pointerEvents: 'none',
                                    }}>$</span>
                                    <input
                                        type="number"
                                        min="0"
                                        value={cargando ? '' : (precios[meta.key] || '')}
                                        disabled={cargando}
                                        onChange={function(e) { handleChange(meta.key, e.target.value); }}
                                        placeholder="0"
                                        style={{
                                            width: '140px',
                                            padding: '10px 12px 10px 28px',
                                            border: '1.5px solid ' + (msg && msg.tipo === 'error' ? '#fca5a5' : '#e5e7eb'),
                                            borderRadius: '10px',
                                            fontSize: '15px',
                                            fontWeight: 700,
                                            color: '#1a1a2e',
                                            outline: 'none',
                                            background: cargando ? '#f9fafb' : '#fff',
                                        }}
                                    />
                                </div>
                                <span style={{ fontSize: '13px', color: '#9ca3af', whiteSpace: 'nowrap' }}>/mes + IVA</span>

                                <button
                                    onClick={function() { guardarPlan(meta.key); }}
                                    disabled={esGuardando || cargando}
                                    style={{
                                        padding: '10px 18px',
                                        background: esGuardando ? '#9ca3af' : '#1a1a2e',
                                        border: 'none', borderRadius: '10px',
                                        color: '#fff', fontWeight: 700, fontSize: '13px',
                                        cursor: esGuardando || cargando ? 'not-allowed' : 'pointer',
                                        display: 'flex', alignItems: 'center', gap: '6px',
                                        whiteSpace: 'nowrap',
                                        transition: 'background .15s',
                                    }}
                                >
                                    {esGuardando
                                        ? <><span className="spinner-border spinner-border-sm" /> Guardando…</>
                                        : <><i className="bi bi-check2" /> Guardar</>
                                    }
                                </button>
                            </div>

                            {/* Mensaje resultado */}
                            {msg && (
                                <div style={{
                                    width: '100%',
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    color: msg.tipo === 'ok' ? '#059669' : '#dc2626',
                                    display: 'flex', alignItems: 'center', gap: '6px',
                                    marginTop: '4px',
                                }}>
                                    <i className={msg.tipo === 'ok' ? 'bi bi-check-circle-fill' : 'bi bi-exclamation-circle-fill'} />
                                    {msg.texto}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>

            <p style={{ fontSize: '12px', color: '#9ca3af', marginTop: '20px' }}>
                Los precios se actualizan en tiempo real. El cache del frontend expira en 5 minutos.
            </p>
        </div>
    );
}
